import { assertNever } from '@/globals/helpers/assert.helpers';
import { ResultType } from './result.types';
import { BaseResultMethods } from './resultMethods.types';
import { AccordionResultMethods } from './accordion/accordionMethods';
import { TextResultMethods } from './text/textMethods';
import { TipResultMethods } from './tip/tipMethods';

export const getResultMethods = (type: ResultType): BaseResultMethods => {
	switch (type) {
		case 'accordion':
			return AccordionResultMethods as BaseResultMethods;
		case 'text':
			return TextResultMethods as BaseResultMethods;
		case 'tip':
			return TipResultMethods as BaseResultMethods;
		default:
			return assertNever(type, `No result methods for type ${type}`);
	}
};
